import { COLORS } from "./metricsMath";

// Mini tendencia para KPIs: barras (última resaltada), barras neto (verde/rojo) o línea.
// Envuelve la mini gráfica separada del texto con un divisor fino para que respire.
const Frame = ({ children, testid }) => (
  <div className="mt-3 pt-2.5 border-t border-zinc-200" data-testid={`${testid}-frame`}>{children}</div>
);

export default function Spark({ rows, k, kind = "bar", color = COLORS.in, testid }) {
  const W = 120, H = 40;
  const vals = rows.map((r) => r[k] ?? 0);
  if (!rows.length) return <Frame testid={testid}><div className="h-10" /></Frame>;
  if (kind === "line") {
    const lo = Math.min(...vals), hi = Math.max(...vals), span = hi - lo || 1;
    const xs = rows.map((_, i) => (rows.length === 1 ? W / 2 : 3 + (i * (W - 6)) / (rows.length - 1)));
    const ys = vals.map((v) => H - 4 - ((v - lo) / span) * (H - 8));
    const d = xs.map((x, i) => `${i ? "L" : "M"}${x.toFixed(1)},${ys[i].toFixed(1)}`).join(" ");
    return (
      <Frame testid={testid}>
        <svg viewBox={`0 0 ${W} ${H}`} preserveAspectRatio="none" className="w-full h-10" data-testid={testid}>
          <path d={d} fill="none" stroke={COLORS.bal} strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" vectorEffect="non-scaling-stroke" />
          <circle cx={xs[xs.length - 1]} cy={ys[ys.length - 1]} r={3} fill={COLORS.bal} />
        </svg>
      </Frame>
    );
  }
  const lo = Math.min(0, ...vals), hi = Math.max(0, ...vals), span = hi - lo || 1;
  const y = (v) => H - 1 - ((v - lo) / span) * (H - 2);
  const bw = W / rows.length, pad = bw * 0.3;
  return (
    <Frame testid={testid}>
      <svg viewBox={`0 0 ${W} ${H}`} preserveAspectRatio="none" className="w-full h-10" data-testid={testid}>
        {vals.map((v, i) => {
          const top = y(Math.max(0, v)), h = Math.max(1.5, Math.abs(y(v) - y(0)));
          const fill = kind === "net" ? (v >= 0 ? COLORS.in : COLORS.out) : i === vals.length - 1 ? color : COLORS.sin;
          return <rect key={i} x={i * bw + pad / 2} width={bw - pad} y={top} height={h} rx={2} fill={fill} />;
        })}
        <line x1={0} x2={W} y1={y(0)} y2={y(0)} stroke="#d4d4d8" strokeWidth={1} vectorEffect="non-scaling-stroke" />
      </svg>
    </Frame>
  );
}
